import React from 'react';

// NOTE: Circular dependency detected
import { MOBILE_TABS, STATISTIC_TAB } from 'modules/match-list/constants';
import { useWidgetSettings } from 'hooks';
import { BettingWidgets } from 'app-constants';
import TopMenu from './TopMenu';

const MobileTopMenu: React.FC<
    Omit<PropsFromReactComponent<typeof TopMenu>, 'homeTabs'>
> = props => {
    const { disableMatchTracker } = useWidgetSettings({
        widget: BettingWidgets.STREAM,
    });

    // NOTE: We rely on "disableMatchTracker" prop to display "statistics" tab on mobile
    // because both features are based on BetRadar integration.
    // Statistics tab is global, can't be disabled for particular sport

    return React.createElement(TopMenu, {
        ...props,
        homeTabs:
            disableMatchTracker === true
                ? MOBILE_TABS
                : [...MOBILE_TABS, STATISTIC_TAB],
    });
};

export default MobileTopMenu;
